import 'bootstrap/dist/css/bootstrap.min.css'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import React from 'react'
import AppRoutes from '@routes'
import { GraphqlProvider, ErrorTrackingAPI, PubSubInitializer } from '@services'
import { ConfirmDialogProvider, OrderEventProvider } from '@context'
import { useAuthInitializer } from '@auth'

ErrorTrackingAPI.initialize()

// Component to initialize authentication management
const AuthInitializer = () => {
    useAuthInitializer()
    return null
}

export default function App() {
    return (
        <ConfirmDialogProvider>
            <OrderEventProvider>
                <GraphqlProvider>
                    <AuthInitializer />
                    <PubSubInitializer>
                        <AppRoutes />
                    </PubSubInitializer>
                </GraphqlProvider>
            </OrderEventProvider>
        </ConfirmDialogProvider>
    )
}
